import React, { Fragment, useState, useId } from 'react';
import { ipaddress, port } from './Parametrizaciones.js';

function ConsultaPago(props) {

    const id = useId();
    const [input, setInput] = useState(props?.value ?? '');

    const traerJson = () => {

        document.getElementById("codigo").value = "";
        document.getElementById("descripcion").value = "";
        document.getElementById("fecha").value = "";
        document.getElementById("monto").value = "";

        fetch('http://' + ipaddress + ':' + port + '/historial_pagos/get/cedula=' + input)

            .then(res => res.json())
            .then(res => {

                document.getElementById("codigo").value = res[0].codigo;
                document.getElementById("descripcion").value = res[0].descripcion;
                document.getElementById("fecha").value = res[0].fechapago;

                const valorOriginal = parseFloat(res[0].monto);

                const valorFormateado = new Intl.NumberFormat('es-CO', {
                    style: 'currency',
                    currency: 'COP',
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0
                }).format(valorOriginal);

                // Asignamos el valor formateado directamente (ya incluye el signo $ y los puntos)
                document.getElementById("monto").value = valorFormateado;

            })
            .catch(err => {
                alert("El registro no existe en nuestra plataforma")

                document.getElementById("codigo").value = "";
                document.getElementById("descripcion").value = "";
                document.getElementById("fecha").value = "";
                document.getElementById("monto").value = "";
            })
    }

    return (
        <Fragment>

            <div class="aa-title">
                <div class="container">
                    <br />
                    <a href='/'>
                        <svg width="50" height="50" fill="currentColor" class="bi bi-house-fill" viewBox="0 0 16 16" style={{ color: '#59abe3' }}>
                            <path d="M8.707 1.5a1 1 0 0 0-1.414 0L.646 8.146a.5.5 0 0 0 .708.708L8 2.207l6.646 6.647a.5.5 0 0 0 .708-.708L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293z" />
                            <path d="m8 3.293 6 6V13.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 13.5V9.293z" />
                        </svg>
                    </a>
                    <h2>Facturación</h2>
                    <span></span>
                </div>
                <br />

                <div class="container">
                    <div className="container mt-5">
                        <div className="card p-3">
                            <div className="row">
                                <div className="container">
                                    <input type="text" style={{ height: '40px', width: 'auto' }} name="cedula" placeholder="Cédula del Titular" id={id} value={input} onInput={e => setInput(e.target.value)} />
                                    <br />
                                    <br />
                                    <button type="button" style={{ height: '40px', width: '40%' }} onClick={traerJson} className="btn btn-primary col-12">Consultar</button>
                                </div>
                            </div>
                            <div>
                                <br />
                                <h2>Apreciado cliente:</h2> 
                                    <br/> Si su factura a cancelar no se ve reflejada en la plataforma, por favor solicitarla en nuestro CHAT EN LINEA
                                <br />
                                <a>Puede contactarnos al (604) 311-0513 | WhatsApp (+57) 333-2840319</a>
                            </div>
                            <br />

                            <div className="table-responsive mt-4">
                                <table className="table table-hover align-middle border">
                                    <thead className="table-light">
                                        <tr>
                                            <th scope="col" className="py-3" style={{ width: '25%' }}>Código Inmueble</th>
                                            <th scope="col" className="py-3" style={{ width: '25%' }}>Descripción</th>
                                            <th scope="col" className="py-3" style={{ width: '25%' }}>Fecha Facturación</th>
                                            <th scope="col" className="py-3 text-end" style={{ width: '25%' }}>Monto a Pagar</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <input
                                                    type="text"
                                                    id="codigo"
                                                    readOnly
                                                    className="form-control-plaintext fw-semibold text-secondary p-0"
                                                    placeholder="—"
                                                />
                                            </td>
                                            <td>
                                                <input
                                                    type="text"
                                                    id="descripcion"
                                                    readOnly
                                                    className="form-control-plaintext text-muted p-0"
                                                    placeholder="—"
                                                />
                                            </td>
                                            <td>
                                                <input
                                                    type="text"
                                                    id="fecha"
                                                    readOnly
                                                    className="form-control-plaintext text-muted p-0"
                                                    placeholder="—"
                                                />
                                            </td>
                                            <td>
                                                <input
                                                    type="text"
                                                    id="monto"
                                                    readOnly
                                                    className="form-control-plaintext text-end fw-bold text-success p-0"
                                                    placeholder="—"
                                                />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>


                        </div>
                    </div>
                </div>
            </div>

        </Fragment>
    )
}

export default ConsultaPago;